import { Behaviour } from "../../../../../types/robot/IRobotEnums";

export const MapIndexToBehaviour = (selectedIndex: number | null) => {
  let result = Behaviour.Sell;
  if (selectedIndex === 1) result = Behaviour.Hold;
  else if (selectedIndex === 2) result = Behaviour.Buy;
  return result;
};

export const MapBehaviourToIndex = (behaviour: Behaviour | null) => {
  if (behaviour === Behaviour.Sell) return 0;
  if (behaviour === Behaviour.Hold) return 1;
  if (behaviour === Behaviour.Buy) return 2;
  return null;
};
